import React from "react"
import { Link } from "gatsby"

import navbarStyles from "../styles/navbar.module.css"
import navbarlogo from "../images/navbarlogo.png"

const Navbar = () => {
  return (
    <nav className={navbarStyles.container}>
      <div>
        <Link to="/">
          <img
            src={navbarlogo}
            alt="guillermo romero logo"
            className={navbarStyles.logo}
          ></img>
        </Link>
      </div>

      <ul className={navbarStyles.navList}>
        <li>
          <Link className={navbarStyles.link} to="/proyectos">
            Proyectos
          </Link>
        </li>
        <li>
          <Link className={navbarStyles.link} to="/sobreMi">
            Sobre mi
          </Link>
        </li>
        <li>
          <Link className={navbarStyles.link} to="/contactame">
            Contactame
          </Link>
        </li>
      </ul>
    </nav>
  )
}

export default Navbar
